import React from "react";

class ApLine extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const a = this.props.from;
    const b = this.props.to;

    const mid = { x: (a.x + b.x) * 0.5, y: (a.y + b.y) * 0.5 };

    const _A = { x: mid.x, y: a.y };
    const _B = { x: mid.x, y: b.y };

    const pathData = `M${a.x},${a.y} C${_A.x},${_A.y} ${_B.x},${_B.y} ${b.x},${
      b.y
    }`;

    return (
      <svg
        className="ApConnectionLine"
        width="100%"
        height="100%"
        style={this.props.bright ? { opacity: 1 } : { opacity: 0.05 }}
      >
        <path
          d={pathData}
          stroke="var(--color-ap-action)"
          strokeWidth="3"
          fill="none"
        />
      </svg>
    );
  }
}

export default ApLine;

/*
        <line
          x1={this.props.from.x}
          y1={this.props.from.y}
          x2={this.props.to.x + 5}
          y2={this.props.to.y + 5}
          style={{ stroke: "white", strokeWidth: 3 }}
        />
*/



// WEBPACK FOOTER //
// ./src/components/approval/ApLine.js